<div class="container">
  <agreements-sign-verdict text="MY_BOOKING" subTitle="AGREEMENT_SIGN_REJECT_TITLE"
                           description="AGREEMENT_SIGN_REJECT_DESCRIPTION"></agreements-sign-verdict>
</div>
